import React from 'react';
import cn from 'classnames';
import { useDeviceDetect } from '@hooks/usedevicedetect';

import '@styles/button.scss';
import Typography from './typography';

interface StepButtonProps {
  ButtonIcon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  direction: string;
  size?: 'small' | 'medium' | 'large';
  step: string;
  onClick?: () => void;
  className?: String;
  disabled?: boolean;
}

export const StepButton: React.FC<StepButtonProps> = ({
  ButtonIcon,
  direction,
  step,
  size = 'medium',
  onClick,
  className,
  disabled,
  ...props
}: StepButtonProps) => {
  const { isMobile } = useDeviceDetect();
  return (
    <button
      className={cn(
        {
          'step-button': 'step-button',
          [`${className}`]: className,
          [`step-button--${size}`]: size,
          [`step-button--${direction}`]: direction,
        },
        isMobile ? 'step-button-mobile' : ''
      )}
      type="button"
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <div className="step-button__icon">
        <ButtonIcon />
      </div>
      <div className="step-button__label">
        <Typography variant="button" size="rg" colour="primary-line">
          {step}
        </Typography>
      </div>
    </button>
  );
};
